export default  {
    maptiler:{
        url:"https://api.maptiler.com/maps/basic/{z}/{x}/{y}@2x.png?key=4vxLshEsCWXsVu9CBUa2"
    }
}